module.exports = __webpack_public_path__ + "static/img/report3d_card.f0bba8b8.png";